export enum PaymentType {
  CreditOrDebitCard = 'CreditOrDebitCard',
  PayPal = 'PayPal',
  PayByCash = 'PayByCash',
  Finance = 'Finance',
  BankTransfer = 'BankTransfer',
}

export enum PaymentCardType {
  CreditCard = 'CreditCard',
  DebitCard = 'DebitCard',
  BankTransfer = 'BankTransfer',
}

export enum PaymentAmountType {
  Balance = 'Balance',
  Custom = 'Custom',
}
